module.exports = ['config', 'Modal', function MyPlaylistModal(config, Modal) {
    var modal;
    return {
        open: function (params, data) {
            modal = Modal.create(
                config.templateRoot + '/templates/playlists/modals/edit',
                params,
                data
            );
            return modal;
        },
        get: function () {
            return modal;
        }
    };
}];



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistclientbundle/Resources/js/angular/services/MyPlaylistModal.js